<script>
import financeMixin from '@mixins/financeMixin'

export default {
  mixins: [financeMixin],
  props: {
    invoiceSummaryData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadInvoice() {
      this.$emit('downloadInvoice')
    },
  },
}
</script>

<template>
  <header class="pl-5">
    <div class="c-subTitle">
      <h4 class="c-title">#{{ invoiceSummaryData.invoiceNumber }}</h4>
      <v-chip
        class="white--text"
        :color="`${isInvoicePaid(invoiceSummaryData)}`"
      >
        {{ isInvoiceLabel(invoiceSummaryData) }}
      </v-chip>
    </div>
    <p class="mt-2 mb-0">
      {{
        $t('finance.invoiceViewInvoiceIssuedText', {
          invoiceDate: displayInvoiceDate(invoiceSummaryData),
        })
      }}
    </p>

    <v-btn color="info" class="mt-2 cl-elevation" @click="downloadInvoice">
      <v-icon class="mr-2" left>mdi-cloud-download</v-icon>
      {{ $t('finance.invoiceViewDownloadBtnText') }}
    </v-btn>
  </header>
</template>

<style lang="scss">
@import '@styles';
.c-subTitle {
  .c-title {
    font-size: 2.5em;
    opacity: 0.8;
    font-weight: bold;
  }
}
</style>
